import { effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CockpitDisplayStateService {
  private displayState = signal('normal');
  private displayFilter = signal(false);
  get _displayState() {
    return this.displayState();
  }

  set _displayState(state: string) {
    localStorage.setItem('displayState', state);
    this.displayState.set(state);
  }

  get _displayFilter() {
    return this.displayFilter();
  }

  set _displayFilter(state: boolean) {
    this.displayFilter.set(state);
  }

  reset(): void {
    this.displayState.set('normal');
    this.displayFilter.set(false);
  }

  constructor() {
    if (localStorage.getItem('displayState')) {
      const state = localStorage.getItem('displayState');
      localStorage.setItem('displayState', state!);
    }
    document.addEventListener('fullscreenchange', () => {
      if (!document.fullscreenElement && this._displayState === 'rdd') {
        this._displayState = 'normal';
      }
    });
    effect(() => {
      if (this._displayState === 'rdd') {
        this.toggleFullscreen(true);
      } else {
        this.toggleFullscreen(false);
      }
    });
  }
  async toggleFullscreen(fullscreen: boolean = false): Promise<void> {
    if (!document.fullscreenElement) {
      const root = document.querySelector('tui-root');

      if (root instanceof HTMLElement && fullscreen) {
        await root.requestFullscreen();
      }
    } else if (!fullscreen) {
      await document.exitFullscreen();
    }
  }
}
